import { useCallback, useState } from "react";
import { literals } from "@/constants/literals";
import PrimaryButton from "@/components/buttons/primary-button/PrimaryButton";
import SecondaryButton from "@/components/buttons/secondary-button/SecondaryButton";
import Textarea from "@/components/textarea/Textarea";
import { appToast } from "@/lib/toast";
import { useLoader } from "@/store/useLoader";
import { sendEditionRequest } from "@/lib/services/order";

export interface RequestEditionDetailsProps {
  photoData: any;
  refetch: () => Promise<void>;
  backToTable: () => void;
  closeRequest: () => void;
  canNotSend: boolean;
}

const RequestEditionDetails = ({
  photoData,
  refetch,
  backToTable,
  closeRequest,
  canNotSend,
}: RequestEditionDetailsProps) => {
  const { upLoader, downLoader } = useLoader();

  const [petition, setPetition] = useState("");

  const sendPetition = useCallback(
    async (
      event: React.BaseSyntheticEvent<
        Event,
        EventTarget & HTMLFormElement,
        EventTarget
      >,
    ) => {
      event.preventDefault();
      if (canNotSend) return;
      try {
        upLoader();
        await sendEditionRequest(photoData.imageId, petition);
        await refetch();
        appToast.success(literals.sentPetition, literals.sentPetitionText);
        downLoader();
        backToTable();
      } catch {
        appToast.error(literals.aProblem, literals.requestError);
        downLoader();
      }
    },
    [
      upLoader,
      downLoader,
      photoData.imageId,
      petition,
      backToTable,
      refetch,
      canNotSend,
    ],
  );

  return (
    <form
      onSubmit={sendPetition}
      className="flex flex-col w-full justify-between"
      data-testid="request-edit-image"
    >
      {" "}
      <div className="w-full my-4">
        <Textarea
          label={literals.askedEdition}
          onChange={(newPetition) => setPetition(newPetition)}
          name="description"
          value={petition}
          deleteMessage={literals.clearText}
          size="medium"
          required
        />
      </div>
      <div className="py-4 flex flex-col gap-4 border-t border-ib-pt-color-gray-300">
        <PrimaryButton
          size="medium"
          label={literals.sendPetition}
          colour="red"
          type="submit"
          onClick={() => {}}
          disabled={petition.trim().length === 0 || canNotSend}
        />
        <SecondaryButton
          size="medium"
          label={literals.cancel}
          colour="red"
          onClick={closeRequest}
        />
      </div>
    </form>
  );
};

export default RequestEditionDetails;
